import { CONTACT_MESSAGES } from '@workspace/constants/contact-form.constant';
import { FormSubmissionResultProps } from '../interfaces';

export function FormSubmissionResult({ result }: FormSubmissionResultProps) {
  if (!result) return null;

  return (
    <div className={`${result.error ? ' text-error' : 'text-black font-body'}`}>
      {result.error ? (
        <div className="leading-6">{result.inlineMessage || CONTACT_MESSAGES.error}</div>
      ) : (
        <div className="flex flex-col space-y-1.5">
          <div className="leading-6">{result.inlineMessage || CONTACT_MESSAGES.success}</div>
          {!result.inlineMessage && <div className="leading-6">{CONTACT_MESSAGES.successSubtext}</div>}
        </div>
      )}
    </div>
  );
}
